import Gap from './src/gap.vue'
import { SFCWithInstall, withInstall } from '@touchvue/utils'

export const ToGap: SFCWithInstall<typeof Gap> = withInstall(Gap)

export * from './src/instance'
